export default __webpack_public_path__ + "static/media/642.cbe3c98f.png";